import React, { PropsWithChildren } from 'react';
import { NamedElementDetailsTooltip } from './NamedElementDetailsTooltip';
import { isPendingSuggestion } from '../../utils';
import { NamedElementRecord } from '@fullstory/proto/fs/services/search-settings';
import { Tooltip } from '@fullstory/components';

export interface NamedElementTooltipProps {
  namedElementRecord: NamedElementRecord;
  onEdit?: () => void;
  canAccess?: boolean;
  className?: string;
  placement?: React.ComponentProps<typeof Tooltip>['placement'];
}

export const NamedElementTooltip: React.FC<PropsWithChildren<NamedElementTooltipProps>> = props => (
  <NamedElementDetailsTooltip
    data-component="NamedElementTooltip"
    {...props}
    namedElementId={props.namedElementRecord.namedElement?.id!}
    suggElementRecord={
      isPendingSuggestion(props.namedElementRecord?.namedElement)
        ? props.namedElementRecord
        : undefined
    }
  />
);
